const collection = document.querySelectorAll('.js-collection');

collection.forEach((elem) => {
  const expanders = elem.querySelectorAll('.js-product-expander');

  expanders.forEach((expander) => {
    const triggers = expander.querySelectorAll('.js-product-trigger');
    const images = expander.parentElement.querySelectorAll('.js-product-image');

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', (event) => {
        
        // Close any other active expanders within the same collection
        expanders.forEach((otherExpander) => {
          if (otherExpander !== expander) {
            const otherExtras = otherExpander.parentNode.querySelector('.js-product-extras');
            if (otherExtras) {
              otherExtras.classList.remove('active');
            }
            const otherTrigger = otherExpander.querySelector('.js-product-trigger.active');
            if (otherTrigger) {
              otherTrigger.classList.remove('active');
            }
            otherExpander.classList.remove('active');

            // Deactivate images in other expanders
            const otherImages = otherExpander.parentElement.querySelectorAll('.js-product-image');
            otherImages.forEach((img) => img.classList.remove('active'));
          }
        });

        // Toggle the specific image corresponding to the trigger index
        images.forEach((image, imgIndex) => {
          if (imgIndex === index) {
            image.classList.toggle('active');
          } else {
            image.classList.remove('active'); // Ensure other images in the same expander are inactive
          }
        });

        // Toggle the current expander
        const extras = expander.parentNode.querySelector('.js-product-extras');
        if (extras) {
          extras.classList.toggle('active');
          trigger.classList.toggle('active');
          expander.classList.toggle('active');
        }
      });
    });
  });
});

document.addEventListener('click', (event) => {
  const mediaItem = event.target.closest('.collection-list .product__media-item');

  if (!mediaItem) return;

  const productItem = mediaItem.closest('.js-product-viewport');
  const productUrl = productItem?.dataset?.productUrl;

  if (!productUrl) return;

  window.location.href = productUrl;
});